import { CarriersTable } from "@/features/carriers/carriers-table";
import { useCenterScopeNotApplicable } from "@/contexts/carrier-scope-context";

export function CarriersListScreen() {
  // The Carriers list IS the carrier roster — center scope doesn't apply.
  useCenterScopeNotApplicable();

  return (
    <div className="p-4">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Carriers</h1>
        <p className="text-gray-600 mt-2">Manage shipping carriers</p>
      </div>
      <CarriersTable />
    </div>
  );
}
